import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';

class Nav extends Component {
    state = {
        navOpened: false
    };

    componentWillMount(){
        if(window.outerWidth <= 768){
            this.closeNav();
        }
    }

    componentWillUpdate(){
        if(window.outerWidth <= 768 && this.lastPathname !== window.location.pathname){
            this.lastPathname = window.location.pathname;
            this.closeNav();
        }
    }

    closeNav = () => {
        this.setState({navOpened: false})
        this.props.openCloseNav(false);
    }

    handleNav = (e) => {
        const navState = this.state.navOpened;
        this.setState({navOpened: !navState});
        this.props.openCloseNav(!navState);
    }

    render() {
        const { isAdmin, loginData, config } = this.props;

        return (
            <nav id="mainNav" className="navigation d-print-none">
                <button type="button" className="simpleBtn" onClick={this.handleNav}><i className="fa fa-chevron-circle-left"></i><span data-mintext="Minimizar" data-maxtext="Maximizar">Minimizar</span></button>
                {/*<NavLink exact activeClassName="active" to="/"><i className="fa fa-home"></i><span>Resumo</span></NavLink>*/}
                {(isAdmin || (loginData.profile.Clients && loginData.profile.Clients.permission > 0)) && <NavLink activeClassName="active" to="/Clients"><i className="fa fa-address-book"></i><span>Clientes</span></NavLink>}
                {(isAdmin || (loginData.profile.Appointments && loginData.profile.Appointments.permission > 0)) && <NavLink activeClassName="active" to="/Appointments"><i className="fa fa-book"></i><span>Marcações</span></NavLink>}
                {(isAdmin || (loginData.profile.Staff && loginData.profile.Staff.permission > 0)) && <NavLink activeClassName="active" to="/Staff"><i className="fa fa-user-md"></i><span>Funcionários</span></NavLink>}
                {config.features.services && (isAdmin || (loginData.profile.Services && loginData.profile.Services.permission > 0)) && <NavLink activeClassName="active" to="/Services"><i className="fa fa-clipboard-list"></i><span>Serviços</span></NavLink>}
                {config.features.products && (isAdmin || (loginData.profile.Products && loginData.profile.Products.permission > 0)) && <NavLink activeClassName="active" to="/Products"><i className="fa fa-boxes"></i><span>Produtos</span></NavLink>}
                {config.features.products && (isAdmin || (loginData.profile.Cart && loginData.profile.Cart.permission > 0)) && <NavLink activeClassName="active" to="/Orders"><i className="fa fa-cash-register"></i><span>Compras</span></NavLink>}
                {(isAdmin || (loginData.profile.Stores && loginData.profile.Stores.permission > 0)) && <NavLink activeClassName="active" to="/Stores"><i className="fa fa-building"></i><span>Lojas</span></NavLink>}
                {config.features.communications && (isAdmin || (loginData.profile.Communications && loginData.profile.Communications.permission > 0)) && <NavLink activeClassName="active" to="/Communications"><i className="fa fa-mail-bulk"></i><span>Comunicações</span></NavLink>}
                {(isAdmin || (loginData.profile.Users && loginData.profile.Users.permission > 0)) && <NavLink activeClassName="active" to="/Users"><i className="fa fa-users"></i><span>Utilizadores</span></NavLink>}
                {config.features.settings && (isAdmin || (loginData.profile.Settings && loginData.profile.Settings.permission > 0)) && <NavLink activeClassName="active" to="/Settings"><i className="fa fa-tools"></i><span>Definições</span></NavLink>}
            </nav>
        );
    }
}

export default Nav;
